import Styles from './SelectImage.module.scss'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { Images } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { useEffect } from 'react'
import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { collectResults } from 'utils/query'
import cx from 'classnames'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'

interface Props {
  isDisabled?: boolean
  imageKeywords?: string[]
  isLoading?: boolean
}

export const StockImages = ({ isDisabled, imageKeywords, isLoading }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const { selectedImages, initialQuery, setProvider, toggleSelectedImage } = imagePickerContext
  const query = imageKeywords?.join(' ') || initialQuery || ''
  const unsplashQuery = useUnsplashImages({ query, perPage: 4 })
  const results = collectResults(unsplashQuery, (data) => data.results || data)
  const stockImages = results.map((item) => {
    return {
      url: item.urls.regular,
      unsplash: {
        authorUsername: item.user.username,
        authorName: item.user.name,
        id: item.id,
        query,
      },
    }
  })

  useEffect(() => {
    if (stockImages.length > 0 && !selectedImages.length) toggleSelectedImage(stockImages[0])
  }, [unsplashQuery.isFetched]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={Styles.imagesSection}>
      <Text variant="largeList">Choose a stock photo</Text>
      <div className={Styles.imagesCard}>
        <div className={Styles.imagesGrid}>
          {(isLoading || stockImages.length === 0) &&
            stockImages.slice(0, 4).map((_, i) => <ShimmeringColor aspectRatio={1} width={152} height={152} key={i} />)}
          {!isLoading &&
            stockImages.slice(0, 4).map((stockImage) => (
              <div
                key={stockImage.unsplash.id}
                className={cx(Styles.image, {
                  [Styles.isSelected]: stockImage.unsplash.id === selectedImages[0]?.unsplash?.id,
                  [Styles.isDisabled]: isDisabled,
                })}
                onClick={() => toggleSelectedImage(stockImage)}
              >
                <img src={stockImage.url} alt="img" />
                {stockImage.unsplash.id === selectedImages[0]?.unsplash?.id && (
                  <>
                    <div className={Styles.checkbox}>
                      <Checkbox size="lg" isSelected aria-label="Selected image" />
                    </div>
                  </>
                )}
              </div>
            ))}
        </div>
        <Button
          frontIcon={Images}
          variant="tertiary"
          isDisabled={stockImages.length === 0 || isDisabled}
          onPress={() => setProvider('stock')}
        >
          Browse all stock photos
        </Button>
      </div>
    </div>
  )
}
